import React, { createContext, useEffect, useState } from "react";
import PlantillaScreen from "../../../helpers/PlantillaScreen";
import { LoaderScreen } from "../../../components/LoaderScreen";
import request from "../../../../Helpers/API";
import Swal from "sweetalert2";
import { TextField } from "@mui/material";
import { useHistory } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { FormatMoney } from "../../../../Helpers/FormatNumber";
import FiltroClientesGestionar2 from "../Components/FiltroClientesGestionar2";
import { useBox } from "../../ReporteCobranza/Helper/useBox";
import { GetKey } from "../../ReporteCobranza/Actions/GetContainer";
import { GetMonthName } from "../../../helpers/GetMonthName";
import { useLocation } from "react-router-dom";

export const ContextConvenio = createContext();
export const ListadoClientesGestionarScreen2 = () => {
  const history = useHistory();
  const location = useLocation();
  const permisos = location.state.permisos;
  const filtrado = location.state.filtro;
  const [selected, setSelected] = useState([]);
  const [predictivo, setPredictivo] = useState("");
  const [clientes, setClientes] = useState([]);
  const [arrayClientes, setArrayClientes] = useState([]);
  const [boxstate, setBoxState] = useBox();
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });
  const storedState = JSON.parse(localStorage.getItem("state")) || {};
  const storedStateGestion = JSON.parse(localStorage.getItem('filtro_gestion')) || {};
  const [titulo, setTitulo] = useState("GESTION DE CLIENTES");

  const [stateFiltro, setStateFiltro] = useState({
    ejercicio: storedStateGestion.ejercicio || storedState.ejercicio || boxstate.ejercicio,
    periodo: storedStateGestion.periodo || storedState.periodo || boxstate.periodo,

    responsable: storedStateGestion.responsable
      ? storedStateGestion.responsable
      : storedState.responsable
        ? storedState.responsable === "CC"
          ? "CCCC"
          : storedState.responsable === "EC"
            ? "EJEC"
            : storedState.responsable === "CS"
              ? "COBS"
              : storedState.responsable === "CN"
                ? "COBN"
                : storedState.responsable === "GC"
                  ? "COBG"
                  : "CCCC"
        : boxstate.responsable,
    adr: storedStateGestion.adr
      ? storedStateGestion.adr
        .filter((item) => item.checked)
        .map(({ idadr, adr }) => ({ idadr, adr }))
      : storedState.adr
        ? storedState.adr
          .filter((item) => item.checked)
          .map(({ idadr, adr }) => ({ idadr, adr }))
        : boxstate.pv.adr,

    sucursal: storedStateGestion.sucursal
      ? storedStateGestion.sucursal
        .filter((item) => item.checked)
        .map(({ idsucursal, sucursal }) => ({ idsucursal, sucursal }))
      : storedState.sucursal
        ? storedState.sucursal
          .filter((item) => item.checked)
          .map(({ idsucursal, sucursal }) => ({ idsucursal, sucursal }))
        : boxstate.pv.sucursal,

    linea: location.state?.linea || storedStateGestion.linea || storedState.linea || boxstate.linea,
    cartera: location.state?.cartera || storedStateGestion.cartera || storedState.cartera || boxstate.cartera,
    gestion: filtrado || storedStateGestion.gestion || storedState.gestion || boxstate.gestion,
  });

  const [isCredito, setIsCredito] = useState(
    location.state?.ruta === undefined ||
      location.state?.ruta === null ||
      location.state?.ruta !== "C"
      ? false
      : true
  );
  const objetivoTotal = clientes.reduce((sum, c) => sum + c.objetivo, 0);
  const capitalTotal = clientes.reduce((sum, c) => sum + c.capital, 0);
  const intNormalTotal = clientes.reduce((sum, c) => sum + c.interes_normal, 0);
  const intMoratorioTotal = clientes.reduce(
    (sum, c) => sum + c.interes_moratorio,
    0
  );
  const total = clientes.reduce((sum, c) => sum + c.saldo_total, 0);
  const recuperadoTotal = clientes.reduce((sum, c) => sum + c.recuperado, 0);
  const saldo = clientes.reduce((sum, c) => sum + c.saldo, 0);

  useEffect(() => {
    setStateFiltro({
      ejercicio: storedStateGestion.ejercicio || storedState.ejercicio || boxstate.ejercicio,
      periodo: storedStateGestion.periodo || storedState.periodo || boxstate.periodo,
      responsable: boxstate.responsable,
      adr: storedStateGestion.adr
        ? storedStateGestion.adr.filter((item) => item.checked).map(({ idadr, adr }) => ({ idadr, adr }))
        : storedState.adr
          ? storedState.adr.filter((item) => item.checked).map(({ idadr, adr }) => ({ idadr, adr }))
          : boxstate.pv.adr,
      sucursal: storedStateGestion.sucursal
        ? storedStateGestion.sucursal.filter((item) => item.checked).map(({ idsucursal, sucursal }) => ({ idsucursal, sucursal }))
        : storedState.sucursal
          ? storedState.sucursal.filter((item) => item.checked).map(({ idsucursal, sucursal }) => ({ idsucursal, sucursal }))
          : boxstate.pv.sucursal,
      linea: storedStateGestion.linea || storedState.linea || boxstate.linea,
      cartera: storedStateGestion.cartera || storedState.cartera || boxstate.cartera,
      gestion: storedStateGestion.gestion || storedState.gestion || boxstate.gestion,
    });
  }, []);

  useEffect(() => {
    setLoader({ ...loader, mostrar: true });
    var sucursales = GetKey(stateFiltro.sucursal, ["idsucursal"]);
    var adr = GetKey(stateFiltro.adr, ["idadr"]);
    if (sucursales === undefined || sucursales === null || sucursales === "") {
      sucursales = GetKey(permisos, ["idsucursal"]);
    }
    if (adr === undefined || adr === null || adr === "") {
      adr = "0";
    }
    request
      .get(
        `ListadoClientesGestionarPrueba/ListadoClientes2?responsable=${stateFiltro.responsable}&sucursal=${sucursales}&adr=${adr}&linea=${stateFiltro.linea}&cartera=${stateFiltro.cartera}&gestion=${stateFiltro.gestion}&ejercicio=${stateFiltro.ejercicio}&periodo=${stateFiltro.periodo}&reporte=${"G"}`
      )
      .then((result) => {
        setClientes(result);
        setArrayClientes(result);
        setTitulo(
          `GESTION DE CLIENTES ${GetMonthName(
            stateFiltro.periodo
          ).toUpperCase()} ${stateFiltro.ejercicio}`
        );
        setLoader({ ...loader, mostrar: false });
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("CONVENIO DE PAGO", JSON.stringify(error), "error");
      });
  }, []);
  // console.log(GetKey(stateFiltro.sucursal, ["idsucursal"]))
  const onExecute = (
    responsable,
    linea,
    cartera,
    gestion,
    ejercicio,
    periodo
  ) => {
    setStateFiltro({
      responsable,
      linea,
      cartera,
      gestion,
      ejercicio,
      periodo,
      adr: boxstate.pv.adr,
      sucursal: boxstate.pv.sucursal
    });
    var sucursales = GetKey(boxstate.pv.sucursal, ["idsucursal"]);
    var adr = GetKey(boxstate.pv.adr, ["idadr"]);
    if (adr === undefined || adr === null || adr === "") {
      adr = "0";
    }
    if (sucursales === undefined || sucursales === null || sucursales === "") {
      if (adr === "0" || adr === "1,2") {
        sucursales = GetKey(permisos, ["idsucursal"]);

      }
      else {
        sucursales = "0"
      }
    }

    return new Promise((resolve, reject) => {
      setLoader({ ...loader, mostrar: true });
      request
        .get(
          `ListadoClientesGestionarPrueba/ListadoClientes2?responsable=${responsable}&sucursal=${sucursales}&adr=${adr}&linea=${linea}&cartera=${cartera}&gestion=${gestion}&ejercicio=${ejercicio}&periodo=${periodo}&reporte=${"G"}`
        )
        .then((result) => {
          setLoader({ ...loader, mostrar: false });
          setClientes(result);
          setArrayClientes(result);
          setTitulo(
            `GESTION DE CLIENTES ${GetMonthName(
              periodo
            ).toUpperCase()} ${ejercicio}`
          );
          return;
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          reject(error);
          return;
        });
    });
  };

  useEffect(() => {
    const result = arrayClientes.filter((item) =>
      item.razon_social.toUpperCase().includes(predictivo.toUpperCase())
    );
    setSelected([]);
    setClientes(result);
  }, [predictivo]);

  const onRegistrar = (idcliente, razonsocial) => {
    history.push("/Creditoycobranza/RegistrarCliente", {
      idcliente,
      razonsocial,
    });
  };
  const onConvenio = (idcliente, razonsocial, responsable) => {
    setLoader({ ...loader, mostrar: true });
    if (idcliente.toString().length <= 6) {
      request
        .get(
          `ObtenerConveniosClienteGestionar/Convenios?idcliente=${Number(
            idcliente
          )}&card=1`
        )
        .then((result) => {
          setLoader({ ...loader, mostrar: false });
          if (result.length > 0) {
            history.push(
              "/Creditoycobranza/DetalleClientesGestionar",
              {
                idcliente,
                razonsocial,
                responsable,
                ruta2:
                  location.state?.ruta === undefined ||
                    location.state?.ruta === null ||
                    location.state?.ruta !== "C"
                    ? "0"
                    : "1",
              }
            );
          } else {
            Swal.fire(
              "CREDITO Y COBRANZA",
              "El cliente no cuenta con un detalle para mostrar",
              "warning"
            );
          }
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          Swal.fire("CONVENIO PAGO", JSON.stringify(error), "error");
        });
    } else {
      Swal.fire(
        "CREDITO Y COBRANZA",
        "El cliente no se encuentra registrado",
        "error"
      );
    }
  };
  const capitalizeWords = (text) => {
    if (!text) return text;
    return text
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const onGeneraExcel = (
    responsable,
    linea,
    cartera,
    gestion,
    ejercicio,
    periodo
  ) => {
    var sucursales = GetKey(stateFiltro.sucursal, ["idsucursal"]);
    var adr = GetKey(stateFiltro.adr, ["idadr"]);
    if (adr === undefined || adr === null || adr === "") {
      adr = "0";
    }
    if (sucursales === undefined || sucursales === null || sucursales === "") {
      if (adr === "0" || adr === "1,2") {
        sucursales = GetKey(permisos, ["idsucursal"]);

      }
      else {
        sucursales = "0"
      }
    }
    setLoader({ ...loader, mostrar: true });
    request
      .get(
        `ListadoClientesGestionarPrueba/ImprimirExcel2?responsable=${responsable}&sucursal=${sucursales}&adr=${adr}&linea=${linea}&cartera=${cartera}&gestion=${gestion}&ejercicio=${ejercicio}&periodo=${periodo}&reporte=${"E"}`
      )
      .then(({ documento, filename }) => {
        const linkSource = `data:application/vnd.ms-excel;base64,${documento}`;
        const downloadLink = document.createElement("a");
        const fileName = `${filename}.xlsx`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
        setLoader({ ...loader, mostrar: false });
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("CREDITO Y COBRANZA", JSON.stringify(error), "error");
      });
  };
  const onGeneraPDF = (
    responsable,
    linea,
    cartera,
    gestion,
    ejercicio,
    periodo
  ) => {
    var sucursales = GetKey(stateFiltro.sucursal, ["idsucursal"]);
    var adr = GetKey(stateFiltro.adr, ["idadr"]);
    if (adr === undefined || adr === null || adr === "") {
      adr = "0";
    }
    if (sucursales === undefined || sucursales === null || sucursales === "") {
      if (adr === "0" || adr === "1,2") {
        sucursales = GetKey(permisos, ["idsucursal"]);

      }
      else {
        sucursales = "0"
      }
    }
    setLoader({ ...loader, mostrar: true });
    request
      .get(
        `ListadoClientesGestionarPrueba/ImprimirPDF2?responsable=${responsable}&sucursal=${sucursales}&adr=${adr}&linea=${linea}&cartera=${cartera}&gestion=${gestion}&ejercicio=${ejercicio}&periodo=${periodo}&reporte=${"G"}`
      )
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        const linkSource = `data:application/pdf;base64, ${result.documento}`;
        const downloadLink = document.createElement("a");
        const fileName = `${result.nombredocumento}.${result.extension}`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("Clientes", JSON.stringify(error), "error");
      });
  };
  return (
    <PlantillaScreen
      titulo={titulo}
      className={"listado-clientes-gestionar-main-screen"}
      className_main={1}
    >
      <div className="listado-clientes-gestionar-actions">
        <div
          className="listado-clientes-gestionar-actions-regresar"
          onClick={() => {
            localStorage.removeItem("filtro_gestion");
            history.goBack();
          }}
        >
          <ArrowBackIcon /> Regresar
        </div>
        <div className="listado-clientes-gestionar-actions-filtro">
          <FiltroClientesGestionar2
            onExecute={onExecute}
            boxState={boxstate}
            onBoxChange={setBoxState}
            linea={location.state?.linea}
            cartera={location.state?.cartera}
            sucursales={permisos}
            gestion={filtrado}
          />
        </div>
        <div className="buttons">
          <button
            className="excel"
            onClick={() =>
              onGeneraExcel(
                boxstate.responsable === 0 ? "CCCC" : boxstate.responsable,
                boxstate.linea,
                boxstate.cartera,
                boxstate.gestion,
                stateFiltro.ejercicio,
                stateFiltro.periodo
              )
            }
          >
            <i className=" icon-file-excel" /> Excel
          </button>
          <button
            className="PDF"
            onClick={() =>
              onGeneraPDF(
                boxstate.responsable === 0 ? "CCCC" : boxstate.responsable,
                boxstate.linea,
                boxstate.cartera,
                boxstate.gestion,
                stateFiltro.ejercicio,
                stateFiltro.periodo
              )
            }
            style={{ backgroundColor: "#940404" }}
          >
            PDF
          </button>
        </div>
      </div>
      <div className="contenedor-superior">
        <div className="clientes-gestionar-resumen">
          {isCredito === false && (
            <div className="objetivo">
              Objetivo: <strong>${FormatMoney(objetivoTotal, 0)}</strong>
            </div>
          )}
          <div className="capital">
            Capital: <strong>${FormatMoney(capitalTotal, 0)}</strong>
          </div>
          <div className="interes-normal">
            Interés normal: <strong>${FormatMoney(intNormalTotal, 0)}</strong>
          </div>
          <div className="interes-moratorio">
            Interés moratorio:{" "}
            <strong>${FormatMoney(intMoratorioTotal, 0)}</strong>
          </div>
          <div className="total">
            Total: <strong>${FormatMoney(total, 0)}</strong>
          </div>
          {/* <div className="recuperado">
                        Recuperado: <strong>${FormatMoney(recuperadoTotal, 0)}</strong>
                    </div> */}
        </div>
        <div className="contador-clientes-encontrados">
          Registros Encontrados: {clientes.length}
        </div>
      </div>
      <LoaderScreen loader={loader} />
      <div className="listado-clientes-gestionar-screen">
        <div className="listado-clientes-gestionar-header">
          <div className="listado-clientes-gestionar-header-control">
            <TextField
              color="success"
              fullWidth
              size="small"
              value={predictivo}
              onChange={({ target }) => setPredictivo(target.value)}
              placeholder="Buscar Clientes..."
            />
          </div>
        </div>
        <div className="listado-clientes-gestionar-container scroll-4">
          {clientes !== undefined &&
            clientes !== null &&
            clientes.length > 0 ? (
            <table cellSpacing={0} cellPadding={0}>
              <thead>
                <tr>
                  <th className="razon-social-celda">Cliente</th>
                  <th>
                    <div>Vencimiento</div>
                  </th>
                  <th>
                    <div>Capital</div>
                  </th>
                  <th>
                    <div>Int. Normal</div>
                  </th>
                  <th>
                    <div>Int. Moratorio</div>
                  </th>
                  <th>
                    <div>Total</div>
                  </th>
                  <th>
                    <div>Objetivo</div>
                  </th>
                  <th>
                    <div>Recuperado</div>
                  </th>
                  <th>
                    <div>Saldo</div>
                  </th>
                  {/* <th>
                                        <div>Teléfono</div>
                                    </th>
                                    <th>
                                        <div>Correo</div>
                                    </th> */}
                  <th>
                    <div>Fecha de Recuperación</div>
                  </th>
                  <th>
                    <div>Fecha de Contacto</div>
                  </th>
                  <th>
                    <div>Fecha Compromiso</div>
                  </th>
                  <th>
                    <div>Convenio</div>
                  </th>
                  <th>
                    <div>Comentario</div>
                  </th>
                  <th>
                    <div>Objecion</div>
                  </th>
                  <th>
                    <div>Observaciones</div>
                  </th>
                  <th className="responsable-celda">
                    <div>Responsable</div>
                  </th>
                  <th>
                    <div>Cultivo</div>
                  </th>
                  {/* <th>
                                        <div style={{ color: 'transparent' }}>d</div>
                                    </th> */}
                </tr>
              </thead>
              <tbody>
                {clientes.map((ctl) => (
                  <tr
                    onClick={() =>
                      onConvenio(
                        ctl.idcliente,
                        ctl.razon_social,
                        ctl.idResponsableCobranza
                      )
                    }
                  >
                    <td className="razon-social-celda sticky-column">
                      {capitalizeWords(ctl.razon_social)}
                    </td>
                    <td className="vencimiento-celda">{ctl.vencimiento}</td>

                    <td className="saldo-celda">
                      {ctl.capital === 0 ? "-" : FormatMoney(ctl.capital, 0)}
                    </td>
                    <td className="saldo-celda">
                      {ctl.interes_normal === 0
                        ? "-"
                        : FormatMoney(ctl.interes_normal, 0)}
                    </td>
                    <td className="saldo-celda">
                      {ctl.interes_moratorio === 0
                        ? "-"
                        : FormatMoney(ctl.interes_moratorio, 0)}
                    </td>
                    <td className="saldo-celda">
                      {ctl.saldo_total === 0
                        ? "-"
                        : FormatMoney(ctl.saldo_total, 0)}
                    </td>
                    <td className="saldo-celda">
                      {ctl.objetivo === 0 ? "-" : FormatMoney(ctl.objetivo, 0)}
                    </td>
                    <td className="saldo-celda">
                      {ctl.recuperado === 0
                        ? "-"
                        : FormatMoney(ctl.recuperado, 0)}
                    </td>
                    <td className="saldo-celda">
                      {/* {FormatMoney(ctl.capital - ctl.recuperado)}{" "} */}
                      {FormatMoney(ctl.saldo)}
                    </td>
                    <td className="fecha-celda">{ctl.fecha_recuperacion}</td>
                    <td className="fecha-celda">{ctl.fecha_contacto}</td>
                    <td className="fecha-celda">{ctl.fecha_compromiso}</td>
                    <td className="convenio-celda">
                      {capitalizeWords(ctl.convenio)}
                    </td>
                    <td className="observaciones-celda">
                      {capitalizeWords(ctl.comentario)}
                    </td>
                    <td className="objecion-celda">
                      {capitalizeWords(ctl.objecion)}
                    </td>
                    <td className="observaciones-celda">
                      {capitalizeWords(ctl.observaciones)}
                    </td>
                    <td className="responsable-celda">{ctl.nombre_responsable}</td>
                    <td className="cultivo-celda">
                      {capitalizeWords(ctl.cultivo)}
                    </td>
                  </tr>
                ))}
                <tr className="total-row">
                  <td className="razon-social-celda"></td>
                  <td className="vencimiento-celda">
                    <strong>Total:</strong>
                  </td>
                  <td className="saldo-celda">
                    <strong>{FormatMoney(capitalTotal, 0)}</strong>
                  </td>
                  <td className="saldo-celda">
                    <strong>{FormatMoney(intNormalTotal, 0)}</strong>
                  </td>
                  <td className="saldo-celda">
                    <strong>{FormatMoney(intMoratorioTotal, 0)}</strong>
                  </td>
                  <td className="saldo-celda">
                    <strong>{FormatMoney(total, 0)}</strong>
                  </td>
                  <td className="saldo-celda">
                    <strong>{FormatMoney(objetivoTotal, 0)}</strong>
                  </td>
                  <td className="saldo-celda">
                    <strong>{FormatMoney(recuperadoTotal, 0)}</strong>
                  </td>
                  <td className="saldo-celda">
                    <strong>
                      {FormatMoney(saldo, 0)}
                      {/* {FormatMoney(capitalTotal - recuperadoTotal, 0)} */}
                    </strong>
                  </td>
                  <td className="fecha-celda"></td>
                  <td className="fecha-celda"></td>
                  <td className="fecha-celda"></td>
                  <td className="convenio-celda"></td>
                  <td className="convenio-celda"></td>
                  <td className="objecion-celda"></td>
                  <td className="observaciones-celda"></td>
                  <td className="responsable-celda"></td>
                  <td className="cultivo-celda"></td>
                </tr>
              </tbody>
            </table>
          ) : (
            <div>Sin Datos</div>
          )}
          <div>
            <table></table>
          </div>
        </div>
      </div>
    </PlantillaScreen>
  );
};
